import { $history, $navigate, setup } from './core'
import { $path } from './path'
import { persistQueryAdapter } from './storage/query'

/** @deprecated To be migrated to TanStack Router */
export const $$router = { $navigate, $history, $path, setup }

/** @deprecated To be migrated to TanStack Router */
export const persistRouter = { query: persistQueryAdapter }
